import { IAppState } from '../../common/state';
import { ISeller } from '../../types/newbuildingHeader';

export function getSellers({ newbuildingInformation }: IAppState): ISeller[] | null {
  return newbuildingInformation?.sellers || null;
}
